import { useCallback, useEffect } from 'react';
import { useFileGeneration, useFileDownloader } from '../../../../api';
import { API_BASE_URL } from '../constants/consts';
import { buildUniversalMfaQueryParams } from '../constants/utils';
import type { QueryFilters } from '../types';

interface Params {
    filters: QueryFilters;
    onSuccess?: () => void;
    onError?: (error: unknown) => void;
}

export const useDownloadAuthenticationFirewallMetricsFile = ({ filters, onSuccess, onError }: Params) => {
    const {
        generate,
        loading: generating,
        error: generateError
    } = useFileGeneration({
        generateUrl: `${API_BASE_URL}/generateMetricsFile`,
        queryParams: buildUniversalMfaQueryParams(filters)
    });

    const {
        downloadFiles,
        downloading,
        error: downloadError
    } = useFileDownloader({ downloadUrl: `${API_BASE_URL}/downloadMetricsFile`, onSuccess });

    const handleGenerateAndDownload = useCallback(async () => {
        const responseIds = await generate();

        if (responseIds) {
            await downloadFiles(responseIds);
        }
    }, [generate, downloadFiles]);

    useEffect(() => {
        if (generateError || downloadError) {
            onError?.(generateError || downloadError);
        }
    }, [generateError, downloadError, onError]);

    return {
        loading: generating || downloading,
        generateAndDownloadAuthenticationFirewallMetricsFile: handleGenerateAndDownload
    };
};
